import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-md" }


export default /*#__PURE__*/_defineComponent({
  __name: 'LzExperts',
  props: {
    title: {},
    description: {},
    itemsSize: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lz-container lz-experts", {'multiples': _ctx.itemsSize == 2, 'multiples-full': _ctx.itemsSize == 3}])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
    ]),
    _renderSlot(_ctx.$slots, "items")
  ], 2))
}
}

})